import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
export function BottomCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      // Show after scrolling 500px, hide if near pricing section
      const scrollY = window.scrollY;
      const pricingEl = document.getElementById('pricing');
      if (pricingEl) {
        const pricingTop = pricingEl.offsetTop;
        const pricingBottom = pricingTop + pricingEl.offsetHeight;
        // Hide when pricing section is fully visible
        const inPricing = scrollY + window.innerHeight > pricingTop + 200 && scrollY < pricingBottom - 100;
        setShow(scrollY > 500 && !inPricing);
      } else {
        setShow(scrollY > 500);
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-63">
      {show && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-id="element-64">
          <div className="max-w-lg mx-auto px-4 py-2.5 flex items-center justify-between gap-3" data-id="element-65">
            {/* Left: Product + Price */}
            <div className="flex items-center gap-3 min-w-0" data-id="element-66">
              <div className="min-w-0" data-id="element-67">
                <p className="text-[11px] md:text-sm font-bold text-[#1A3A5C] truncate leading-tight" data-id="element-68">
                  Mesas Epoxi Pro 🎁
                </p>
                <div className="flex items-center gap-2 mt-0.5" data-id="element-69">
                  <span className="text-[15px] md:text-lg font-extrabold text-[#15803D] leading-none" data-id="element-70">
                    $690
                  </span>
                  <span className="text-[11px] md:text-sm text-gray-400 line-through leading-none" data-id="element-71">
                    $1.490
                  </span>
                </div>
              </div>
            </div>

            {/* Right: CTA Button */}
            <a href="https://resinartesanal.store/cart/51954451415353:1" onClick={trackAddToCart} rel="noopener" className="flex-shrink-0 bg-gradient-to-r from-[#C9A84C] to-[#E5C877] text-[#0F2340] font-extrabold text-[13px] md:text-sm px-5 py-2.5 rounded-md shadow-md hover:shadow-lg transition-all hover:-translate-y-[1px] active:translate-y-0 uppercase tracking-wide whitespace-nowrap" data-id="element-72">
              Lo quiero
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}